<template>
  <DashboardLayout>
      <LoadingSpinner :isLoading="isLoading" />
    <ToastManagerVue ref="toastManager" />
    <div class="payment-container">
      <div class="payment-main">
        <svg
          v-if="statusval == 'success'"
          width="107"
          height="106"
          viewBox="0 0 107 106"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2206_8007)">
            <path
              d="M57.5036 105.999H49.36C49.2197 105.707 48.9419 105.791 48.7197 105.791C46.8888 105.796 45.0765 105.484 43.3144 105.116C37.7795 103.964 32.4826 102.126 27.543 99.3223C21.7938 96.0589 16.7112 92.0316 12.4912 86.9409C9.02265 82.7587 6.2155 78.2063 4.0883 73.2049C1.81295 67.8701 0.490064 62.3122 0.122303 56.5757C-0.160794 52.1729 0.0297012 47.7518 0.881637 43.3726C1.99815 37.6335 3.92162 32.2121 6.82138 27.1215C10.3429 20.9361 14.8433 15.6039 20.5026 11.2248C25.1724 7.61223 30.2549 4.78469 35.8481 2.85765C40.24 1.3428 44.751 0.353033 49.3917 0.137751C51.376 0.0458628 53.3657 -0.0617781 55.3764 0.0327359C58.5461 0.182383 61.6734 0.492178 64.7663 1.14065C71.4389 2.53735 77.6326 5.10761 83.2866 8.88292C87.7474 11.8627 91.6578 15.4543 95.0576 19.6129C98.8437 24.2414 101.759 29.3347 103.767 34.9399C105.027 38.4553 105.958 42.0468 106.429 45.767C106.556 46.7673 106.276 47.8962 107.001 48.7993V51.4929C104.738 49.4189 102.474 47.3475 100.214 45.2655C97.0419 42.3408 93.8961 39.3899 90.6921 36.502C90.065 35.9375 89.5094 35.2365 88.6734 34.9163C88.2315 34.3124 88.049 33.5668 87.4775 33.0181C85.9059 31.5164 84.2708 30.0619 82.8633 28.4132C80.3445 25.4649 75.9737 25.5515 73.447 27.9248C70.96 30.2614 68.5867 32.7188 66.1632 35.1237C59.5462 41.6898 52.9212 48.248 46.3253 54.8351C45.7591 55.3995 45.4442 55.4625 44.878 54.8456C43.8144 53.6825 42.6635 52.5956 41.5417 51.4851C38.8589 48.8256 36.1682 46.1792 33.4907 43.5144C31.3344 41.3695 27.7943 41.0465 25.3788 42.8633C23.2383 44.4727 21.4551 46.4732 19.6269 48.4055C17.9891 50.1356 17.6134 52.2937 18.3146 54.5909C18.7167 55.9062 19.6084 56.8934 20.5608 57.8385C27.4425 64.6776 34.3241 71.5194 41.2084 78.3585C41.8301 78.9781 42.5709 79.4428 43.3038 79.9154C43.2641 80.5245 43.7351 80.829 44.0949 81.1887C51.5507 88.5923 59.0064 95.9906 66.4675 103.389C66.7374 103.657 67.039 103.89 67.3274 104.14C65.4833 104.694 63.6259 105.182 61.6998 105.392C60.2949 105.544 58.898 105.791 57.4983 105.996L57.5036 105.999Z"
              fill="#32BA7C"
            />
            <path
              d="M88.6736 34.9206C89.5096 35.2409 90.0652 35.9419 90.6923 36.5063C93.8963 39.3943 97.0421 42.3452 100.214 45.2699C102.471 47.3492 104.739 49.4206 107.001 51.4973V57.2994C106.792 57.3703 106.816 57.5541 106.789 57.7195C106.464 59.8618 106.204 62.0093 105.765 64.1359C104.585 69.8435 102.408 75.1652 99.426 80.1455C96.5077 85.0182 92.8354 89.2845 88.4937 92.9968C85.1864 95.827 81.6147 98.2213 77.736 100.201C74.4129 101.897 70.9681 103.265 67.3328 104.142C67.0444 103.892 66.7428 103.658 66.473 103.391C59.0119 95.9924 51.5535 88.594 44.1004 81.1904C43.7405 80.8307 43.267 80.5288 43.3093 79.9171C44.2565 80.0878 45.2169 80.1796 46.172 80.0799C47.3891 79.9512 48.6749 79.6572 49.503 78.8171C51.8022 76.4805 54.104 74.1386 56.4085 71.8125C63.8854 64.2619 71.4205 56.7638 79.1091 49.4206C80.1039 48.4702 80.9373 47.3387 81.9851 46.4513C83.6545 45.0415 85.1044 43.4216 86.6839 41.9304C88.7635 39.9666 89.335 37.6247 88.6736 34.918V34.9206Z"
              fill="#0AA06E"
            />
            <path
              d="M88.6727 34.9215C89.3315 37.6283 88.7627 39.9701 86.6831 41.9339C85.1036 43.4251 83.6511 45.045 81.9842 46.4548C80.9365 47.3396 80.1057 48.4711 79.1083 49.4241C71.4197 56.7673 63.8846 64.2628 56.4076 71.8161C54.1032 74.1448 51.8014 76.4866 49.5022 78.8206C48.6741 79.6633 47.3882 79.9574 46.1712 80.0834C45.216 80.1832 44.2556 80.0913 43.3085 79.9206C42.5756 79.4481 41.8348 78.9807 41.213 78.3638C34.3287 71.5246 27.4497 64.6829 20.5655 57.8438C19.613 56.8986 18.7214 55.9115 18.3192 54.5961C17.6181 52.2989 17.9911 50.1409 19.6315 48.4107C21.4571 46.4811 23.2403 44.4779 25.3834 42.8685C27.8016 41.0518 31.3417 41.3721 33.4953 43.5196C36.1728 46.1844 38.8636 48.8334 41.5464 51.4903C42.6682 52.6009 43.8191 53.6878 44.8827 54.8508C45.4462 55.4678 45.7637 55.4048 46.3299 54.8403C52.9258 48.2532 59.5508 41.695 66.1679 35.1289C68.5914 32.724 70.9646 30.2693 73.4516 27.9301C75.9757 25.5567 80.3491 25.4701 82.8679 28.4184C84.2728 30.0645 85.9105 31.519 87.4821 33.0233C88.0536 33.5694 88.2362 34.315 88.678 34.9215H88.6727Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_2206_8007">
              <rect width="107" height="106" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <svg
          v-if="statusval == 'failure'"
          width="107"
          height="106"
          viewBox="0 0 107 106"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_2206_8243)">
            <path
              d="M0.516295 56.9341V49.0659C0.705131 48.9767 0.707753 48.7984 0.712999 48.6279C0.815285 45.9082 1.32409 43.2645 1.94568 40.6155C3.2413 35.0894 5.42079 29.9541 8.40807 25.1493C11.7416 19.7884 15.8461 15.1252 20.8503 11.2489C25.2617 7.83407 30.0298 5.08284 35.291 3.21808C38.8081 1.97229 42.3881 0.999258 46.1202 0.576999C47.269 0.445863 48.4912 0.548149 49.5796 0H57.2406C57.7782 0.322595 58.4129 0.3462 58.9847 0.38554C61.3661 0.540281 63.7056 0.959917 66.0005 1.53429C70.8866 2.75911 75.555 4.56092 79.9376 7.0866C85.4191 10.247 90.1557 14.2886 94.2262 19.1039C97.0719 22.4715 99.4349 26.1774 101.315 30.1718C102.981 33.7072 104.258 37.3791 105.1 41.2056C105.575 43.3615 105.85 45.541 106.154 47.7231C106.404 49.4987 106.285 51.2716 106.427 53.042C106.537 54.4346 106.472 55.9296 106.257 57.3354C106.11 58.3031 106.348 59.3181 105.91 60.2413C105.981 59.6591 105.646 59.2893 105.263 58.9142C101.961 55.6857 98.6534 52.4623 95.3776 49.2075C90.5098 44.3686 85.6683 39.5035 80.8084 34.654C80.5251 34.3708 80.31 33.9695 79.8301 33.9564C79.539 33.6627 79.2505 33.3689 78.9593 33.0752C78.7128 32.0628 77.9601 31.5146 77.1077 31.0583C76.1189 30.1036 75.0961 29.183 74.1493 28.189C71.8098 25.7289 67.359 25.5847 64.9933 28.1077C61.8566 31.4517 58.5336 34.62 55.2893 37.859C54.9273 38.221 54.4972 38.5226 54.1457 38.8714C53.5897 39.4222 53.3091 39.2648 52.8423 38.7927C49.5455 35.4566 46.1648 32.2018 42.931 28.808C41.5881 27.397 40.1693 26.3977 38.2075 26.1617C36.5368 25.9623 35.0549 26.298 33.7305 27.3366C31.8814 28.7844 30.3681 30.5783 28.6791 32.1939C28.2411 32.6136 27.769 32.9755 27.4805 33.5682C26.2059 36.17 26.2295 39.152 28.5506 41.4207C32.2014 44.9876 35.7814 48.6253 39.3903 52.2342C39.5608 52.4046 39.7339 52.5725 39.8991 52.7508C40.0591 52.9266 40.0565 53.021 39.844 53.2282C36.5237 56.4856 33.2321 59.7719 29.917 63.0372C29.0856 63.8581 28.3172 64.7236 27.6484 65.6835C26.219 67.7345 26.3344 70.31 27.4753 72.1931C28.5506 73.9687 30.2213 75.2354 31.5825 76.7697C31.4225 77.1369 31.6952 77.0189 31.8631 77.0189C32.3116 77.4621 32.7601 77.9028 33.2085 78.346C33.2453 79.1538 33.8537 79.6049 34.3494 80.1032C42.5245 88.2914 50.71 96.4716 58.8903 104.655C59.1814 104.946 59.4489 105.258 59.7295 105.562C58.7381 106.042 57.6287 105.911 56.6137 105.945C53.3615 106.047 50.1068 106.052 46.852 105.625C43.8516 105.232 40.9115 104.636 38.0448 103.726C32.9751 102.116 28.186 99.9677 23.793 96.8624C22.1564 95.7058 20.5382 94.5282 18.975 93.2824C16.8795 91.6091 15.0488 89.6552 13.2863 87.6331C11.7442 85.8627 10.2807 84.019 9.06375 82.0283C7.24096 79.0515 5.52307 76.0013 4.26154 72.7229C3.43539 70.5775 2.5253 68.4505 2.05846 66.2002C1.59948 63.9866 1.05395 61.7887 0.852003 59.5122C0.775944 58.673 1.02773 57.7314 0.513672 56.9341H0.516295Z"
              fill="#F15249"
            />
            <path
              d="M105.915 60.2459C105.057 66.2703 103.337 72.0219 100.496 77.4195C98.5187 81.1805 96.1399 84.6556 93.3257 87.8579C89.2212 92.5264 84.4557 96.3346 79.0502 99.3743C75.2892 101.491 71.3027 103.075 67.1588 104.229C64.738 104.903 62.2727 105.485 59.7339 105.567C59.4559 105.262 59.1857 104.95 58.8946 104.659C50.7143 96.4762 42.5314 88.2959 34.3538 80.1078C33.8555 79.6094 33.247 79.1583 33.2129 78.3505C33.6037 78.6076 33.9761 78.8908 34.3852 79.1138C37.0185 80.5379 39.8563 79.9766 42.1039 77.7526C45.6341 74.2617 49.1459 70.7551 52.6263 67.2144C53.2846 66.5457 53.6439 66.6243 54.2629 67.2564C57.4993 70.5532 60.7908 73.7949 64.043 77.0733C64.8901 77.9283 65.8186 78.6495 66.8572 79.2554C68.6616 80.3097 72.2154 80.0396 73.5215 78.5525C75.2027 76.6379 77.1094 74.9541 78.8404 73.0972C80.8757 70.9151 80.9386 66.8289 78.746 64.6861C75.027 61.0537 71.3971 57.3347 67.6938 53.6891C67.1221 53.1278 67.1798 52.8577 67.7148 52.3305C71.4443 48.6508 75.1371 44.9318 78.8483 41.2338C79.8816 40.203 80.2278 38.8943 80.4324 37.5095C80.6186 36.2532 79.9184 35.1621 79.8318 33.9609C80.3144 33.9741 80.5268 34.378 80.8101 34.6586C85.67 39.5054 90.5115 44.3732 95.3793 49.2121C98.6551 52.4669 101.962 55.6902 105.264 58.9188C105.647 59.2938 105.983 59.6636 105.912 60.2459H105.915Z"
              fill="#AD0E0E"
            />
            <path
              d="M79.8338 33.9586C79.9177 35.1598 80.618 36.2508 80.4344 37.5071C80.2298 38.8919 79.8862 40.198 78.8503 41.2314C75.1391 44.932 71.4463 48.6484 67.7168 52.3281C67.1818 52.8579 67.1241 53.1254 67.6958 53.6867C71.3991 57.3323 75.0316 61.0539 78.748 64.6838C80.9432 66.8265 80.8776 70.9127 78.8424 73.0948C77.1114 74.9517 75.2047 76.6355 73.5235 78.5501C72.2174 80.0372 68.6636 80.3099 66.8592 79.253C65.8206 78.6471 64.8921 77.9233 64.045 77.0709C60.7928 73.7925 57.4987 70.5508 54.2649 67.254C53.6459 66.622 53.2866 66.5433 52.6283 67.2121C49.1479 70.7527 45.6361 74.2593 42.1059 77.7502C39.8582 79.9716 37.0205 80.5329 34.3872 79.1114C33.9781 78.8911 33.6057 78.6052 33.2149 78.3482C32.7664 77.9049 32.3179 77.4617 31.8668 77.0211C31.7724 76.9371 31.6806 76.8558 31.5862 76.7719C30.225 75.2376 28.5543 73.9734 27.479 72.1952C26.3381 70.3095 26.2227 67.734 27.6521 65.6856C28.3209 64.7257 29.0867 63.8602 29.9207 63.0393C33.2359 59.774 36.5274 56.4878 39.8478 53.2303C40.0576 53.0231 40.0628 52.9287 39.9028 52.753C39.7402 52.5746 39.5645 52.4068 39.394 52.2363C35.7852 48.6274 32.2051 44.9897 28.5543 41.4228C26.2332 39.1542 26.2096 36.1721 27.4842 33.5704C27.7727 32.9777 28.2448 32.6157 28.6828 32.1961C30.3692 30.5805 31.8852 28.7865 33.7342 27.3388C35.0587 26.3028 36.5405 25.9645 38.2112 26.1638C40.173 26.3999 41.5919 27.3991 42.9347 28.8101C46.1685 32.2066 49.5466 35.4614 52.846 38.7949C53.3128 39.2669 53.5961 39.4243 54.1495 38.8735C54.5009 38.5247 54.931 38.2231 55.293 37.8612C58.5373 34.6195 61.8603 31.4512 64.997 28.1099C67.3627 25.5894 71.8135 25.7311 74.153 28.1912C75.0998 29.1852 76.1226 30.1058 77.1114 31.0604C77.6438 31.8105 78.1867 32.5502 78.963 33.0773L79.8338 33.9586Z"
              fill="white"
            />
            <path
              d="M78.963 33.0794C78.1866 32.5522 77.6437 31.8126 77.1113 31.0625C77.9637 31.5189 78.7164 32.067 78.963 33.0794Z"
              fill="#F15249"
            />
            <path
              d="M31.5876 76.7695C31.6794 76.8535 31.7738 76.9348 31.8682 77.0187C31.7004 77.0187 31.4276 77.1367 31.5876 76.7695Z"
              fill="#AD0E0E"
            />
          </g>
          <defs>
            <clipPath id="clip0_2206_8243">
              <rect
                width="105.969"
                height="106"
                fill="white"
                transform="translate(0.515625)"
              />
            </clipPath>
          </defs>
        </svg>
        <div v-if="statusval == 'success'" class="success-text">Payment Successful</div>
        <div v-if="statusval == 'failure'" class="success-text">Payment not successful</div>
        <div v-if="statusval == 'success'">Your payment was successful</div>
        <div v-if="statusval == 'failure'">Your payment was not successful</div>
        <div v-if="statusval">
        <BaseButton
          :label="statusval == 'success' ? 'Back to dashboard' : 'Back to payment page'"
          backgroundColor="var(--s-pink-normal)"
          textColor="white"
          height="60px"
          width="341px"
          @click="() => (statusval == 'success' ? backToDashboard() : backToPayment())"
        />
        </div>
      </div>
    </div>
  </DashboardLayout>
</template>
<script>
import { ref, onMounted } from "vue";
import DashboardLayout from "@/views/Dashboard/Caregiver/IndexPage.vue";
import BaseButton from "@/components/BaseButton.vue";
import { useRouter, useRoute } from "vue-router";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Request from "@/utils/apiclient.js";
export default {
  name: "PaymentStatus",
  components: {
    DashboardLayout,
    BaseButton,
      LoadingSpinner,
  },
  setup() {
    const statusval = ref(false);
    const router = useRouter();
    const backToDashboard = () => {
      router.push("/careseeker/home");
    };
    const backToPayment = () => {
      router.push("/careseeker/payment");
    };

    const isLoading = ref(true);
    const route = useRoute();
let reference;
if (route.query.reference && route.query.reference !== ""){
reference = route.query.reference;
}else if (route.query.paymentReference && route.query.paymentReference !== ""){
  reference = route.query.paymentReference;
}
    
    console.log("reference gotten from route", reference);
    if (!reference) {
      console.error("No token provided in the URL");
      isLoading.value = false;
      return;
    }

     const request = new Request(`payment/verify_payment/?reference=${reference}`);
    //const request = new Request(`payment/verify_payment/?reference=27tf5u3nov`);
    onMounted(() => {
      request.get((res, error) => {
        isLoading.value = false;
        if (error) {
           console.log("payment verification response:", error);
          statusval.value = "failure";
          //   console.error("Error:", error);
          //    console.log("error here", error)
          //   if (error.message == "Email already verified.") {
          //     emailVerified.value = "already_verified";
          //   } else {
          //     emailVerified.value = "failed";
          //   }
        } else {
          console.log("payment verification response:", res);
          if (res.status == "success") {
            if (res.data.status == 1) {
              statusval.value = "success";
            } else {
              statusval.value = "failure";
            }
          }

          //   setTimeout(() => {
          //     router.push("/login");
          //   }, 3000);
        }
      });
    });
    return { backToDashboard, statusval, backToPayment,  LoadingSpinner, isLoading };
  },
};
</script>
<style scoped>
.payment-container {
  display: flex;
  width: 100%;
  justify-content: center;
}
.payment-main {
  margin-top: 59px;
  background-color: #fef5f7;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  align-items: center;
  padding: 42px 70px;
  width: 485px;
  border-radius: 12px;
}
.cost {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 32px;
  padding-bottom: 16px;
  border-bottom: 1px solid #979797;
}
.cost-total {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 32px;
  padding-bottom: 16px;
}
.pay-with-paystack {
  width: 311px;
  height: 60px;
  padding: 16px 24px 16px 24px;
  gap: 10px;
  border-radius: 40px;
  border: 1px solid black;
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 35px;
}
span {
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 27.2px;
  letter-spacing: 0.5px;
  text-align: left;
}
.reason {
  width: 100%;
  margin-top: 32px;
}
ul {
  list-style-position: inside;
}
h2 {
  font-family: Inter;
  font-size: 24px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: 0.5px;
  text-align: center;
}
.success-text {
  font-family: Inter;
  font-size: 24px;
  font-weight: 700;
  line-height: 34px;
  letter-spacing: 0.5px;
  text-align: center;
}
</style>